var Direction;
(function (Direction) {
  Direction["RTL"] = "rtl";
  Direction["LTR"] = "ltr";
  Direction["AUTO"] = "auto";
})(Direction || (Direction = {}));

export { Direction };
//# sourceMappingURL=direction.mjs.map
